<template>
  <div>
    <base-spinner></base-spinner>
  </div>
</template>
<script>
import { onMounted } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  setup() {
    const router = useRouter();
    const store = useStore();
    onMounted(async () => {
      const code = router.currentRoute.value.query.code;
      const codeVerifier = window.sessionStorage.getItem("codeVerifier");

      if (!code || !codeVerifier) {
        return;
      }
      await store.dispatch('auth/authenticate', { "code": code, "codeVerifier": codeVerifier });
      router.replace("/home");
    });
  },
};
</script>